{
  "name": "@ns/company-connect-request",
  "version": "1.1.0",
  "requiredPermission": "RELATIONSHIPS_MANAGE",
  "description": "Create a commercial relationship and invite one or more companies to join it",
  "inputs": {
    "BASE_COMPANY_ID": {
      "type": "string"
    },
    "PRESELECTED_CONNECTOR_ID": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "submit": {
      "inputs": {
        "notes": {
          "type": "string"
        }
      }
    },
    "cancel": {}
  }
}
